// @flow
import React from 'react';
import { connect } from 'react-redux';
import { useTheme } from '@material-ui/styles';
import Fab from '@material-ui/core/Fab';

import KeyboardImage from '../../../assets/images/keyboard.png';

interface Props {
  onClick: Function;
  keyboardInputShown: boolean;
}

const KeyboardButton = ({ onClick, keyboardInputShown }: Props) => {
  const theme = useTheme();

  return (
    <Fab
      style={{ backgroundColor: keyboardInputShown ? theme.palette.ava.blue : theme.palette.ava.grey }}
      onClick={onClick}
    >
      <img src={KeyboardImage} alt="reply by keyboard" height="20" />
    </Fab>
  );
};

const mapStateToProps = ({
  scribeConversation: {
    ui: { keyboardInputShown },
  },
}) => ({ keyboardInputShown });

export default connect(mapStateToProps)(KeyboardButton);
